import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Footer } from 'src/shared';

const OCTContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%);
  color: white;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(30, 58, 138, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.25);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin: 0;
  text-shadow: 0 4px 8px rgba(30, 58, 138, 0.4);
`;

const Content = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const OCTCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: 40px;
  max-width: 800px;
  text-align: center;
`;

const OCTIcon = styled.div`
  font-size: 5rem;
  margin-bottom: 20px;
`;

const OCTTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #60a5fa;
`;

const OCTDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
`;

const FeatureList = styled.ul`
  text-align: left;
  font-size: 1rem;
  line-height: 1.8;
  opacity: 0.9;
`;

const OCT: React.FC = () => {
  const navigate = useNavigate();

  return (
    <OCTContainer>
      <Header>
        <BackButton onClick={() => navigate('/medical_imaging')}>
          ← Back to Medical Imaging
        </BackButton>
        <Title>OCT Imaging</Title>
        <div style={{ width: '120px' }}></div>
      </Header>

      <Content>
        <OCTCard>
          <OCTIcon>👁️</OCTIcon>
          <OCTTitle>Optical Coherence Tomography</OCTTitle>
          <OCTDescription>
            High-resolution retinal imaging technology that provides detailed cross-sectional 
            views of the retina and optic nerve for precise diagnosis and monitoring.
          </OCTDescription>
          
          <FeatureList>
            <li><strong>Retinal Imaging:</strong> Detailed cross-sectional retinal analysis</li>
            <li><strong>Optic Nerve:</strong> Precise optic nerve head evaluation</li>
            <li><strong>Macular Analysis:</strong> Central vision area examination</li>
            <li><strong>Layer Segmentation:</strong> Automated retinal layer identification</li>
            <li><strong>Thickness Mapping:</strong> Retinal thickness measurements</li>
            <li><strong>Disease Detection:</strong> Early detection of retinal pathologies</li>
          </FeatureList>
        </OCTCard>
      </Content>

      <Footer />
    </OCTContainer>
  );
};

export default OCT;
